import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {MatDivider} from "@angular/material/divider";

import {TranslocoPipe} from "@ngneat/transloco";
import {DatePipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {DocummentsService} from "../../../documents.service";
import {GeneralFieldNames} from "../../../document-types";
import {BasicInfoFieldNames} from "../../../basic-info/basic.patient.info.types";
import {BasicTemplate} from "../../../base-behaviour/template";
import {getRawVal, getValueOfFieldWithName} from "../../../base-behaviour/base.behaviour.doc.types";
import {ChestEvalGenStareSanFieldNames} from "../../chest-eval-gen-stare-sanatate.types";
import {bulInfQuestions, BullInfAnsw} from "../buletin-informativ-types";

@Component({
    selector: 'buletin-informativ-sib-v2-template',
    templateUrl: 'buletin-informativ-template-sib-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIcon,
        MatDivider,
        TranslocoPipe,
        NgIf,
        NgClass,
        NgForOf,
        DatePipe

    ],
    standalone: true,
    styles: `
        ul {
            list-style-type: none;
            margin-left: 1cm;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
        }

        thead {
            background-color: #cdcdcd;
            color: black;
            text-align: center;
        }

        .leftAlignHead {
            background-color: #cdcdcd;
            color: black;
            text-align: left;
        }

        th, td {
            border: 1px solid black;
            padding: 8px;
        }

        body {
            font-family: Arial, sans-serif;
            background-color: #ffffff;
            margin: 0;
            padding: 0;
        }

        .content-container {
            width: 95%;
            padding: 1.5cm 1cm 1.5cm 1cm;
        }

        h1 {
            font-size: x-large;
            text-align: center;
            font-weight: bold;
        }

        h4 {
            color: #8e8e8e;
            text-align: right;
            font-size: small;
            font-weight: bold;
        }

    `
})
export class BuletinInformativTemplateSibV2 extends BasicTemplate implements OnInit, OnDestroy {
    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GeneralFieldNames = GeneralFieldNames;

    constructor(
        route: ActivatedRoute,
        router: Router,
        _docsService:DocummentsService,
        _cdref: ChangeDetectorRef,
    ) {
        super(_docsService, _cdref, router, route);
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this.destroy();
    }

    getFieldData(key: string) {
        return getValueOfFieldWithName(this.docFields, key, this.documentID);
    }

    protected readonly getValueOfFieldWithName = getValueOfFieldWithName;
    protected readonly ChestEvalGenStareSanFieldNames = ChestEvalGenStareSanFieldNames;
    protected readonly bulInfQuestions = bulInfQuestions;

    replacePlaceHoldersIn(answ: BullInfAnsw) {
        let res = answ.txt.replace(
            "{tick}",
            this.getBooleanFieldDataSimple(answ.id,"☑", "☐" ,answ.inverted));

        if(res.includes("{extra}")){
            let value = this.getValueOfFieldWithName(this.docFields, answ.id+"extra");
            value = !value ? "" : value;
            res = res.replace(
                "{extra}",
                value);
        }
        return res;
    }

    convertTimestampToDate(timestamp: string): Date | null {
        if (!timestamp) {
            return null;
        }

        try {
            return new Date(timestamp);
        } catch (error) {
            console.error('Invalid timestamp format:', timestamp, error);
            return null;
        }
    }
}
